import { Button } from '@chakra-ui/react'
import { wwtMemo } from '@wwt/custom/wwt'

import { FeatureIsNotImplemented } from '@wwt/ui/components'

import { cn } from '@/shared/lib/cn'

interface ReservationTabTemplateForSideBlockElementProps {
	title: string
	description: string
	buttonText: string
	onClick?: () => void
	isImplemented?: boolean
	className?: string
}

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabTemplateForSideBlockElement = wwtMemo(
	({
		title,
		description,
		buttonText,
		onClick,
		isImplemented = true,
		className
	}: ReservationTabTemplateForSideBlockElementProps) => {
		return (
			<section
				className={cn('flex w-full flex-col gap-y-4 sm:gap-y-6', className)}
			>
				<h2 className="ts-headline-4">{title}</h2>
				<div className="ts-6">{description}</div>

				{isImplemented ? (
					<Button
						mt={{ base: '0.5rem', sm: '2.25rem', lg: 0 }}
						w="full"
						/* TODO: Use font size from theme */
						fontSize="1rem"
						variant="outline"
						size="sm"
						onClick={onClick}
					>
						{buttonText}
					</Button>
				) : (
					<FeatureIsNotImplemented>
						<Button
							mt={{ base: '0.5rem', sm: '2.25rem', lg: 0 }}
							w="full"
							/* TODO: Use font size from theme */
							fontSize="1rem"
							variant="outline"
							size="sm"
							onClick={onClick}
							isDisabled
						>
							{buttonText}
						</Button>
					</FeatureIsNotImplemented>
				)}
			</section>
		)
	}
)
